module.exports = __webpack_public_path__ + "img/gfit2.7aa102ac.jpg";